/* eslint-disable vue/require-default-prop */
import Vue from 'vue';
import DropHint from './base';
import { genNbsp } from "../../../lib/designer/utils/generatorNbsp";
// [面积,文本]
const TextBySize = [[6000, '放到这里面'], [4000, '放里面'], [0, genNbsp(8)]];
export default class InsertEmptySlotHint extends DropHint {
  constructor() {
    super(...arguments);
    this.hintClassName = 'isBlockHint';
  }
  getRect() {
    const {
      offsetWidth,
      offsetHeight
    } = this.ownerSlot.slotContainerElement;
    const zoomPercentage = this.designer.getZoomPercentage();
    return {
      x: 0,
      y: 0,
      width: offsetWidth * zoomPercentage,
      height: offsetHeight * zoomPercentage
    };
  }
  getDescription() {
    const {
      applyDefaults
    } = this.config;
    if (applyDefaults) {
      return this.designer.$createElement(ApplyDefaultTiming, {
        attrs: {
          applyDefaults
        }
      });
    }
    const areaSize = this.getAreaSize();
    const ans = TextBySize.find(obj => obj[0] <= areaSize);
    return ans[1];
  }
  getRelatedCompPath() {
    return null;
  }
  async execute() {
    const {
      designer,
      config: {
        applyDefaults
      }
    } = this;
    if (typeof applyDefaults === 'function') {
      await applyDefaults();
      await Vue.nextTick();
    }
    const toRemoveCompPath = this.editZoneState.currentDraggingCompPath;
    const insertPoint = `${this.ownerSlot.compPath}/${this.ownerSlot.slotId}/0`;
    const {
      layout
    } = designer.dragSource;
    const newCompPath = await designer.spliceComp(toRemoveCompPath, insertPoint, layout);
    designer.compPath = newCompPath || '';
  }
}
const ApplyDefaultTiming = Vue.extend({
  props: {
    applyDefaults: Function
  },
  data() {
    return {
      handlePointerMove: null,
      timer: null,
      progress: 0,
      width: 24,
      height: 24,
      radius: 10
    };
  },
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "display: flex; align-items: center; gap: 4px; padding: 4px"
    }, [h("svg", {
      "attrs": {
        "width": this.width,
        "height": this.height
      }
    }, [h("path", {
      "attrs": {
        "d": this.getPathData(),
        "stroke": "currentColor",
        "stroke-width": "3",
        "fill": "none"
      }
    })]), "\u5373\u5C06\u6253\u6563\u63D2\u69FD"]);
  },
  methods: {
    getPathData() {
      const centerX = this.width / 2;
      const centerY = this.height / 2;
      const startAngle = -Math.PI / 2; // Starting angle at top center
      const endAngle = Math.PI * 2 * this.progress + startAngle;
      // Calculate the arc path coordinates
      const startX = centerX + Math.cos(startAngle) * this.radius;
      const startY = centerY + Math.sin(startAngle) * this.radius;
      const endX = centerX + Math.cos(endAngle) * this.radius;
      const endY = centerY + Math.sin(endAngle) * this.radius;
      // Create the path string
      const largeArcFlag = this.progress <= 0.5 ? 0 : 1;
      const pathData = `M ${startX} ${startY} A ${this.radius} ${this.radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
      return pathData;
    }
  },
  beforeDestroy() {
    window.removeEventListener('dragover', this.handlePointerMove, true);
    clearInterval(this.timer);
  },
  created() {
    const duration = 1200;
    let deadline = Date.now() + duration;
    let cX = 0;
    let cY = 0;
    this.handlePointerMove = ev => {
      if ((cX - ev.clientX) ** 2 + (cY - ev.clientY) ** 2 > 25) {
        // 鼠标抖动5px后重置计时器
        deadline = Date.now() + duration;
        cX = ev.clientX;
        cY = ev.clientY;
      }
    };
    window.addEventListener('dragover', this.handlePointerMove, true);
    this.timer = setInterval(() => {
      this.progress = 1 - Math.max(0, deadline - Date.now()) / duration;
      if (this.progress >= 1) {
        this.applyDefaults();
        clearInterval(this.timer);
      }
    });
  }
});
//# sourceMappingURL=InsertEmptySlotDropHint.js.map
